module.exports = __webpack_public_path__ + "img/herramientas_electricas.269e0d8c.png";